import { map } from 'nanostores'

import type { DeliveryZone } from '@/models/delivery-zone'

export const $deliveryZones = map<Record<string, DeliveryZone | undefined>>()
export const $zipDeliveryZoneIds = map<Record<string, number>>()
export const $promises = map<Record<string, Promise<any> | undefined>>()

export const loggables = {
  'delivery-zone/$deliveryZones': $deliveryZones,
  'delivery-zone/$zipDeliveryZoneIds': $zipDeliveryZoneIds,
  // 'delivery-zone/$promises': $promises,
}
